module.exports = __webpack_public_path__ + "static/images/styles/images/button-small/bsm-default-active-bg-right.b2cd45be.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/button-small/bsm-default-active-bg-right.png
// module id = 3589
// module chunks = 11